import React, { Component, ErrorInfo, ReactNode } from "react";
import { captureEvent } from "@/lib/posthog";

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false
    };

    public static getDerivedStateFromError(_: Error): State {
        return { hasError: true };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
        captureEvent("$exception", {
            $exception_type: error.name,
            $exception_message: error.message,
            $exception_stack: error.stack,
            componentStack: errorInfo.componentStack
        });
    }

    public render() {
        if (this.state.hasError) {
            return (
                <div className="flex flex-col items-center justify-center min-h-screen bg-background p-4 text-center">
                    <h1 className="text-2xl font-bold mb-2">Ops! Algo deu errado.</h1>
                    <p className="text-muted-foreground mb-4">
                        Ocorreu um erro inesperado. Nossa equipe já foi notificada.
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
                    >
                        Recarregar página
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}
